import React from 'react';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import { adminCategories } from '../adminData';

function AdminCategories() {
  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Categories</h1>
          <p>Organize products into categories for easier browsing.</p>
        </div>
        <button className="admin-btn-primary">
          <Plus size={16} /> Add Category
        </button>
      </div>

      <div className="admin-category-grid">
        {adminCategories.map(cat => (
          <div key={cat.id} className="admin-category-card">
            <div className="admin-category-swatch" style={{ background: cat.color }}></div>
            <h3>{cat.name}</h3>
            <p>{cat.products} product{cat.products !== 1 ? 's' : ''}</p>
            <div className="admin-category-revenue">{cat.revenue.toLocaleString()} SAR</div>
            <div className="admin-row-actions center">
              <button className="admin-icon-action"><Edit2 size={14} /></button>
              <button className="admin-icon-action danger"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminCategories;
